/* BI-12 · ADD-LOCATION MOMENT
   FQ-I4 (« NO Growth »): several establishments are Multi's, from plans.js — 10 included, then +9 €/mois each,
   self-serve with the calculation shown. No mandatory call. V1 sells one establishment (nine-answers § 6), so the
   frame is the multi plan's only (the nine-locations world); elsewhere it is Votre offre. */
import { Navigate } from 'react-router-dom'
import { Button, Card, Note, Rule } from '@/ui'
import { getPlan } from '@/lib/campaign'
import { eur, extraLocationAmount, planLocations } from '@/lib/plans'
import { Head, useBill } from './ParamShell'

export default function BI12Etablissement() {
  const a = useBill().addLocation
  if (getPlan() !== 'multi') return <Navigate replace to="/parametres/offre" />
  const next = planLocations('multi') + 1
  return (
    <section data-frame="BI-12" style={{ display: 'grid', gap: 14 }}>
      <Head title="Ajouter un établissement" />
      <Note tone="ok">
        {a.included}<strong>{a.used}</strong>. Celui-ci est inclus, rien à payer.
      </Note>
      <Rule>{`et au ${next}ᵉ\u00A0?`}</Rule>
      <Card>
        <strong>{`À partir du ${next}ᵉ\u00A0:`}</strong> {`+${eur(extraLocationAmount())}/mois par établissement, en
        libre-service, avec l’aperçu de calcul.`} Aucun appel obligatoire.
      </Card>
      <div><Button variant="primary" size="sm">Créer l’établissement</Button></div>
    </section>
  )
}
